import CONSTANTS from "@/common/constants";

const myPage = [
  {
    path: "/mypage",
    component: () => import("@/views/MyPage/MyPage.vue"),
    children: [
      {
        path: "/settlements",
        name: CONSTANTS.ROUTE.NAME.SETTLEMENTS,
        component: () => import("@/views/MyPage/Settlements.vue"),
        meta: {
          auth: CONSTANTS.ROUTE.CODE.MYPAGE,
          layout: "FULL",
        },
      },
      {
        path: "/profile",
        name: CONSTANTS.ROUTE.NAME.PROFILE,
        component: () => import("@/views/MyPage/Profile.vue"),
        meta: {
          auth: CONSTANTS.ROUTE.CODE.MYPAGE,
          layout: "FULL",
        },
      },
      {
        path: "/requestpapers",
        name: CONSTANTS.ROUTE.NAME.REQUESTPAPERS,
        component: () => import("@/views/MyPage/RequestPapers.vue"),
        meta: {
          auth: CONSTANTS.ROUTE.CODE.MYPAGE,
          layout: "FULL",
        },
      },
    ],
  },
];

export default myPage;
